import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Camera, MessageCircle, Star, Smile, TrendingUp } from 'lucide-react';
const moments = [{
  icon: Heart,
  title: 'Convidados elogiando',
  description: '"Que lembrancinha linda! Onde você comprou?" E você sorrindo por dentro, sabendo que custou centavos.'
}, {
  icon: Camera,
  title: 'Fotos perfeitas',
  description: 'Lembrancinhas que ficam lindas nas fotos do casamento. Detalhes que você vai querer mostrar para sempre.'
}, {
  icon: MessageCircle,
  title: 'Madrinhas comentando',
  description: '"Você tem bom gosto!" "Ficou tão elegante!" "Parece coisa de loja cara!" Validação que aquece o coração.'
}, {
  icon: Star,
  title: 'Sogra impressionada',
  description: 'Aquele olhar de aprovação. Aquele comentário positivo. Você provou que sabe fazer as coisas com classe.'
}, {
  icon: Smile,
  title: 'Sensação de orgulho',
  description: 'Você olha para as lembrancinhas e sente orgulho genuíno. Você fez. Você conseguiu. E ficou lindo.'
}, {
  icon: TrendingUp,
  title: 'Economia gigantesca',
  description: 'Você gastou R$200 em vez de R$2.000. E ninguém percebeu a diferença. Só você sabe o segredo.'
}];
export function FuturePacingSection() {
  return <section className="py-24 bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50" data-id="element-56">
      <div className="max-w-6xl mx-auto px-6" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-58">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-59">
            Imagine o Dia do Seu Casamento Assim...
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-60">
            Feche os olhos por um momento e visualize essa cena:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-61">
          {moments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-lg text-center" data-id="element-62">
              <div className="bg-gradient-to-br from-rose-100 to-pink-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-63">
                <moment.icon className="w-8 h-8 text-rose-600" data-id="element-64" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-65">
                {moment.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-66">
                {moment.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}